module.exports = __webpack_public_path__ + "img/line-circle.7434e83c.svg";